module.exports = __webpack_public_path__ + "/bundle/asset/U2_03-8ca59c22317c2998ee050e7838578b5b.gif";